import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RowStyled, ColStyled, FlexWrapperStyled } from './styled';
export function SectionHOC(props) {
    const { headerLeftSide, headerRightSide, bottomSection, children, isRightToLeft, bgColor } = props;
    return (React.createElement(Container, null,
        React.createElement(RowStyled, null,
            React.createElement(ColStyled, null,
                React.createElement(FlexWrapperStyled, { bg: bgColor, isRightToLeft: isRightToLeft },
                    React.createElement(Container, { expanded: true, maxWidth: "100%" },
                        React.createElement(Row, { mb: "16px", mdMb: "24px", lgMb: "32px" },
                            React.createElement(Col, { md: 4, lg: 6, justifyContent: "flex-start" }, headerLeftSide),
                            headerRightSide && (React.createElement(Col, { md: 4, lg: 6, justifyContent: "flex-end", display: "flex" }, headerRightSide))),
                        React.createElement(Row, null,
                            React.createElement(Col, null, children)),
                        bottomSection && (React.createElement(Row, { mt: "24px" },
                            React.createElement(Col, null,
                                React.createElement(FlexWrapper, { alignItems: "center", justifyContent: "center" }, bottomSection))))))))));
}
SectionHOC.displayName = 'SectionHOC_Component';
